<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode">专家讲坛</li>
            </ul>
            <div class="page-main">
                    <h3>专家讲坛</h3>
                    <ul class="expert-forum-list">
                        <li class="expert-forum" v-for="expert in expertList" :key="expert.Id">
                            <img :src="expert.ImageUrl" />
                            <div class="expert-forum-des">
                                <h4 @click="goDetail(expert)">{{ expert.Title }}</h4>
                                <p class="ellipsis_three">
                                    <!-- {{  }} -->
                                </p>
                                <p class="date">
                                    <img data-v-05516b2a="" src="/img/time.34508e5d.png">
                                    <i data-v-05516b2a="">{{ expert.UpdateTime }}</i>
                                </p>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange">
                    </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getExpertList
} from '@services/indexService.js';
export default {
    name: '',
    data() {
        return {
            expertList: [],
            total: 0,
            currentPage:1,
            pageSize: 10,
            id: 1 // 1信息分会
        };
    },
    created() {
        this.getExpertList();
        console.log(this.data);
    },
    methods: {
        getExpertList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                id: this.id
            };
            getExpertList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.expertList = res.Data;
                    this.total = res.Count;
                } else {
                    this.expertList = [];
                    this.$message.error("专家讲坛请求失败");
                }
            })
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/export-forum-detail',
                query: {
                    id: data.Id
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getExpertList();
        },
    },
};
</script>

<style scoped>
.page-main {
    display: block;
    background: #fff;
    padding: 30px 30px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}
.expert-forum-list {
    padding-top:20px;
    padding-bottom: 10px;
}
.expert-forum {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 20px;
}
.expert-forum img {
    width: 218px;
    height: 137px;
}
.expert-forum-des {
    padding-left: 20px;
}
.expert-forum-des h4 {
    color: #262626;
    font-family: 思源黑体 CN;
    font-size: 18px;
    margin: 0;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}
.expert-forum-des h4:hover {
    color: #116EBA;
}
.expert-forum-des p {
    color: #6a6a6a;
    font-family: 思源黑体 CN;
    font-size: 14px;
}
.expert-forum-des .date{
    padding-top: 10px;
    color: #A1A8B0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.expert-forum-des .date img{
    width: 15px;
    height: 15px;
}
.expert-forum-des .date i {
    font-style: normal;
}
</style>